//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			tel: ''
		}
	},
	mounted() {
		this.getOrgMobile()
	},
	methods: {
		getOrgMobile() {
			this.$rest('open/org_mobile')
			.get()
			.success(res => {
				this.tel = res.org_mobile
			})
			.error(res => {
				this.alert('error',res.body.message)
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/public/appforgetpwd.vue